/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  FormControl,
  ControlLabel,
  FormGroup,
  Pagination,
  Modal,
  Tooltip,
} from "react-bootstrap";
import Select from "react-select";
import {
  DeleteNotificationTemplate,
  searchLeadForOrder,
  is_featured_status_change,
  GroupMemberList,
  searchNotification,
  AssignLeadToGroup,
  getPushNotification,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";
import LoadingSpinner from "views/Components/loadingSpinner";

import SweetAlert from "react-bootstrap-sweetalert";

import Switch from "react-bootstrap-switch";

import Card from "components/Card/Card.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
class ViewNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      couponcode_detail: [],
      couponcode_category_detail: [],
      category: [],
      groupHolders: [],
      category_name: "",
      itemcode: "",
      title: "",
      couponcodecategory: "",
      price: "",
      commision: "",
      unitprice: "",
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      subscriberItems: [],
      loading: false,
      p_couponid: null,
      tabledata: [],
      page: "",
      _notificationSystem: null,
      alert: null,
      useraccess: "",
      couponcodefile: null,
      city: "0",
      showbulkui: 0,
      noRecordFound: false,
      is_flash_medicine: "",
      is_featured: "",
      city_info: [],
      subscriber: [],
      usertrasactionmodal: false,
      push_notifications: [],
      currentSendPN: "",
      currentclickedPN: "",
      S_paginationData: [],
      S_nextpage: "",
      S_prevpage: "",
      S_currentPage: 1,
      S_nextdisabled: "1",
      S_prevdisabled: "1",
      S_loading: false,
      S_page: "",
      currentInsightId: "",
    };
    this.fileInput = React.createRef();
    this.scrollTopEl = React.createRef();
    // this.submitbulkcouponcode = this.submitbulkcouponcode.bind(this);
    this.selectedNotification = this.selectedNotification.bind(this);
    this.deleteMedicaton = this.deleteMedicaton.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.s_paginationinfo = this.s_paginationinfo.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.searchData = this.searchData.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.openusertrasactionmodal = this.openusertrasactionmodal.bind(this);
    this.closeusertrasactionmodal = this.closeusertrasactionmodal.bind(this);
    this.addbulkcouponcode = this.addbulkcouponcode.bind(this);
    // this.handleInputChange = this.handleInputChange.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
    this.inputOnChangeSubscriber = this.inputOnChangeSubscriber.bind(this);
  }
  closeusertrasactionmodal() {
    this.setState({ usertrasactionmodal: false, push_notifications: [] });
  }
  openusertrasactionmodal(id) {
    this.setState({ usertrasactionmodal: true, currentInsightId: id });
    this.searchNotificationInsight(id, 1);
  }
  searchNotificationInsight(id, page) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    getPushNotification(id, page, obj).then((res) => {
      if (res.success != false) {
        var data = res.data.notifications;
        var no_pages = [];
        let serach_string = "";
        for (var i = 1; i <= data.last_page; i++) {
          if (serach_string == "") {
            no_pages.push(i);
          } else {
            no_pages.push(i);
          }
        }

        if (data.current_page == data.last_page) {
          this.setState({ S_prevdisabled: null });
          this.setState({ S_nextdisabled: "1" });
        } else if (data.current_page == 1) {
          this.setState({ S_nextdisabled: null });
          this.setState({ S_prevdisabled: "1" });
        } else {
          this.setState({ S_nextdisabled: null });
          this.setState({ S_prevdisabled: null });
        }
        if (data.last_page == 1) {
          this.setState({ S_nextdisabled: 1 });
          this.setState({ S_prevdisabled: 1 });
        }
        if (data.length == 0) {
          no_pages = [];
          this.setState({ S_nextdisabled: 1 });
          this.setState({ S_prevdisabled: 1 });
        }
        this.setState({ S_currentPage: data.current_page });
        if (data.next_page_url != null) {
          if (serach_string == "") {
            this.setState({
              S_nextpage: data.next_page_url.substring(
                data.next_page_url.indexOf("=") + 1
              ),
            });
          } else {
            this.setState({
              S_nextpage: data.next_page_url.substring(
                data.next_page_url.indexOf("=") + 1
              ),
            });
          }
        } else {
          this.setState({ S_nextpage: "#" });
        }
        if (data.prev_page_url != null) {
          if (serach_string == "") {
            this.setState({
              S_prevpage: data.prev_page_url.substring(
                data.prev_page_url.indexOf("=") + 1
              ),
            });
          } else {
            this.setState({
              S_prevpage: data.prev_page_url.substring(
                data.prev_page_url.indexOf("=") + 1
              ),
            });
          }
        } else {
          this.setState({ S_prevpage: "#" });
        }

        this.setState({ S_paginationData: no_pages });

        var sendNotification = res.data.sent_notifications;
        var clickedNotification = res.data.clicked_notifications;

        this.setState({
          S_loading: false,
          push_notifications: data,
          currentSendPN: sendNotification,
          currentclickedPN: clickedNotification,
        });
      }
    });
  }
  selectedNotification(cus) {
    localStorage.setItem("notificationID", JSON.stringify(cus));

    this.props.history.push("/admin/edit_notification");
  }
  sendToParentSubscriber = async () => {
    if (this.state.subscribername.length !== 0) {
      let compelte = 1;
      let pg_no = 1;
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var city_id = this.state.city_id;
      await searchLeadForOrder(this.state.subscribername, obj).then((res) => {
        const data = res.data.data;
        let subscriberItems = [];
        res.data.data.map((x, i) => {
          subscriberItems.push({
            value: x.id,
            label: x.name + " (" + x.mobile_no + ")",
          });
        });

        this.setState({
          subscriber_detail: data,
          subscriberItems: subscriberItems,
        });
      });
    } else {
      this.setState({
        subscriberItems: [],
        subscriber_detail: [],
      });
    }
  };
  inputOnChangeSubscriber = (event) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      subscribername: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParentSubscriber(self.state.subscribername);
      }, 300),
    });
  };
  async componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    this.searchData();
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({
      useraccess: token.role,
    });

    let pg_no = 1;
    var country_id = "1";
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {getApiErrorMessage(error)}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
    this.searchdata();
  };
  paginationinfo(url) {
    this.setState({ page: url });
    this.searchData();
  }
  s_paginationinfo(url) {
    this.searchNotificationInsight(this.state.currentInsightId, url);
  }
  searchdata(e) {
    this.setState({ page: "" });
    this.searchData();
  }
  resetSearch(e) {
    this.setState({
      itemcode: "",
      title: "",
      couponcodecategory: "",
      price: "",
      commision: "",
      unitprice: "",
      city: "0",
    });
    this.searchData();
  }
  subStrAfterChars(str, char, pos) {
    if (pos == "b") return str.substring(str.indexOf(char) + 1);
    else if (pos == "a") return str.substring(0, str.indexOf(char));
    else return str;
  }
  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ noRecordFound: false });
    this.setState({ loading: true }, () => {
      searchNotification(this.state.page, obj)
        .then((response1) => {
          var data = response1;
          var couponcode_category = data.data;
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          var $no_pages = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(i);
            } else {
              $no_pages.push(i);
            }
          }

          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
              });
            } else {
              this.setState({
                nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
              });
            } else {
              this.setState({
                prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }
          this.setState({ paginationData: $no_pages });

          this.setState({
            loading: false,
            tabledata: data.data.data,
            couponcode_category_detail: couponcode_category,
          });
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl", error);
        });
    });
  }
  closeCancelModal() {
    this.setState({ showCouponModal: false });
  }
  closeCancelassignModal() {
    this.setState({ showGroupHolderModal: false });
  }
  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deleteMedicaton(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Notification Template Detail !
        </SweetAlert>
      ),
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  addbulkcouponcode() {
    this.setState({
      showbulkui: 1,
    });
  }
  closemedicatonupload() {
    this.setState({
      showbulkui: 0,
    });
  }
  is_feature_change(id, feature) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var is_featured = "";
    if (feature == "1") {
      is_featured = 0;
    } else if (feature == "0") {
      is_featured = 1;
    }
    is_featured_status_change(is_featured, id, obj).then((res) => {
      if (res.data.success == true) {
        this.searchData();
      }
    });
  }
  groupMember(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    GroupMemberList(id, obj)
      .then((response) => {
        this.setState({
          groupHolders: response.data[0].leads,
          showGroupHolderModal: true,
        });
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl", error);
      });
  }
  assignMember(coupon_id) {
    var tag = [];
    this.state.subscriber.map((data) => {
      var array1 = tag;
      var array2 = array1.concat(data.value);
      tag = array2;
    });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    AssignLeadToGroup(tag, this.state.p_couponid, obj)
      .then(() => {
        this.setState({
          showCouponModal: false,
        });
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl", error);
      });
  }
  assignMemberModal(id) {
    this.setState({
      showCouponModal: true,
      p_couponid: id,
    });
  }
  deleteMedicaton(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    DeleteNotificationTemplate(id, obj)
      .then(() => {
        // alert('category deleted');
        // window.location.href="#/admin/couponcode-category";
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl", error);
      });
  }
  addcouponcode() {
    this.props.history.push("/admin/addnotification");
  }
  onSubscriberChange = (value) => {
    this.setState({
      subscriber: value,
    });
  };
  render() {
    const change_status = (
      <Tooltip id="change_status">Change Feature Status</Tooltip>
    );

    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const assign = <Tooltip id="payment">Assign to user</Tooltip>;
    const couponowner = <Tooltip id="couponowner">Assigned to</Tooltip>;
    const couponcode = this.state.tabledata;
    const getPushNotifications = this.state.push_notifications;

    var c = 1;

    const add_Commisson_array = { 1: "Yes", 0: "No" };

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <Row>
                    {this.state.useraccess == 8 ? (
                      ""
                    ) : (
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          className="text-right"
                        >
                          <Button
                            className="fl_mb_web_1 btn-fill fl_mb_1 w_150 "
                            class="btn-color" //bsStyle="info" fill
                            onClick={this.addcouponcode.bind(this)}
                          >
                            Add Notifictaion <i className="fa fa-plus"></i>
                          </Button>
                          <br />
                          &nbsp;
                          {/* <Button  className="fl_mb_web_1 btn-fill fl_mb_1 w_150 " onClick={this.addbulkcouponcode.bind(this)}  bsStyle="info" fill  >Add Bulk couponcode</Button> */}
                        </Col>

                        {/* {this.state.showbulkui == 1 ? 
                    <Col xs={12} sm={12} md={12} lg={12} > 
                    <h5>Upload couponcode details</h5>
                    <form>
                      <FormGroup>
                      <ControlLabel>Bulk couponcode</ControlLabel>
                      <input type="file"  name="couponcodefile" onChange={this.handleInputChange}  placeholder="select file" />
                      </FormGroup>
                      <FormGroup>
                        <Button fill onClick={this.submitbulkcouponcode.bind(this)} bsStyle="success">Submit</Button>
                        &nbsp;
                        <Button fill  onClick={this.closemedicatonupload.bind(this)} bsStyle="danger">close</Button>
                        &nbsp;
                        <Button fill  onClick={this.exportfile.bind(this)} bsStyle="danger">export</Button>
                        
                      </FormGroup>
                    </form>
                    </Col>
                    : ''} */}
                      </Col>
                    )}
                    <br />
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Title</th>
                            <th>Content</th>
                            <th>Screen Link</th>
                            <th>External Link</th>
                            <th>Notification Insights</th>
                            {this.state.useraccess == 1 && (
                              <th className="text-right">Actions</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colspan="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.noRecordFound ? (
                            <tr>
                              <td colspan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <React.Fragment>
                              {couponcode.map((cus) => (
                                <tr>
                                  <td>{cus.title}</td>
                                  <td>{cus.content}</td>
                                  <td>{cus.link}</td>
                                  <td>
                                    {cus.url ? (
                                      <a href={cus.url} target="_blank" >
                                        <button>Link</button>
                                      </a>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    <Button
                                      onClick={this.openusertrasactionmodal.bind(
                                        this,
                                        cus.id
                                      )}
                                    >
                                      <i
                                        style={{ fontSize: "16px" }}
                                        className="fa fa-file-text"
                                      ></i>
                                    </Button>
                                  </td>
                                  {this.state.useraccess == 4 ||
                                  this.state.useraccess == 6 ||
                                  this.state.useraccess == 7 ||
                                  this.state.useraccess == 8 ||
                                  this.state.useraccess == 9 ||
                                  this.state.useraccess == 10 ? (
                                    ""
                                  ) : (
                                    <td className="td-actions text-right no-padding">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={edit}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.selectedNotification.bind(
                                            this,
                                            cus.id
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-edit" />
                                        </Button>
                                      </OverlayTrigger>

                                      {this.state.useraccess == 1 && (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={remove}
                                        >
                                          <Button
                                            simple
                                            bsStyle="danger"
                                            onClick={this.warningWithConfirmAndCancelMessage.bind(
                                              this,
                                              cus.id
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-times" />
                                          </Button>
                                        </OverlayTrigger>
                                      )}
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </React.Fragment>
                          )}
                        </tbody>
                      </Table>
                      {this.state.loading ? (
                        ""
                      ) : this.state.noRecordFound ? (
                        ""
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          <Pagination>
                            <Pagination.First
                              dataUrl={this.state.prevpage}
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.prevpage
                              )}
                              disabled={this.state.prevdisabled}
                            />
                            {this.state.paginationData.map((url) => (
                              <Pagination.Item
                                dataUrl={url}
                                active={
                                  this.state.currentPage == c ? "1" : null
                                }
                                onClick={this.paginationinfo.bind(this, url)}
                              >
                                {c++}
                              </Pagination.Item>
                            ))}
                            <Pagination.Last
                              dataUrl={this.state.nextpage}
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.nextpage
                              )}
                              disabled={this.state.nextdisabled}
                            />
                          </Pagination>
                        </div>
                      )}
                    </Col>

                    <Modal
                      show={this.state.showGroupHolderModal}
                      onHide={() =>
                        this.setState({ showGroupHolderModal: true })
                      }
                    >
                      <Modal.Header>
                        <Modal.Title>Assigned To ...</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <FormGroup>
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Mobile No.</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.groupHolders.map((cus) => (
                                <tr>
                                  <td> {cus.name}</td>
                                  <td>{cus.mobile_no}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </FormGroup>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={this.closeCancelassignModal.bind(this)}
                          bsStyle="info"
                          fill
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    <Modal
                      show={this.state.showCouponModal}
                      onHide={() => this.setState({ showCouponModal: true })}
                    >
                      <Modal.Header>
                        <Modal.Title>Assign Coupon</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <FormGroup>
                          <ControlLabel>Select Customer</ControlLabel>
                          <div
                            onKeyUp={(e) => this.inputOnChangeSubscriber(e)}
                            className="Appy2"
                            style={{ textTransform: "capitalize" }}
                          >
                            <Select
                              style={{ textTransform: "capitalize" }}
                              className="react-select primary"
                              classNamePrefix="react-select"
                              name="subscriber"
                              value={this.state.healthcondition}
                              onChange={(value) =>
                                this.onSubscriberChange(value)
                              }
                              isMulti
                              options={this.state.subscriberItems}
                              placeholder="Subscriber"
                              noOptionsMessage={() =>
                                "Type Name or Phone Number"
                              }
                            />
                          </div>
                          {this.state.assigncutomerError}
                        </FormGroup>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={this.assignMember.bind(this)}
                          bsStyle="success"
                          fill
                        >
                          Submit
                        </Button>
                        &nbsp;
                        <Button
                          onClick={this.closeCancelModal.bind(this)}
                          bsStyle="info"
                          fill
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </Row>
                }
              />
              <Modal
                className="custom-modal-style"
                bsSize="lg"
                show={this.state.usertrasactionmodal}
                aria-labelledby="example-modal-sizes-title-lg"
                onHide={() => this.setState({ usertrasactionmodal: true })}
              >
                <Modal.Header className="pn_insight_popupheader">
                  <h4>Push Notification Insights</h4>
                  {getPushNotifications.data ? (
                    <div className="push_noti_detailswrap">
                      <div className="push_noti_rowdetials">
                        <h4>Push Notification Sent</h4>
                        <span>{this.state.currentSendPN}</span>
                      </div>
                      <div className="push_noti_rowdetials">
                        <h4>Push Notification Clicked</h4>
                        <span>{this.state.currentclickedPN}</span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "75vh", overflow: "auto" }}>
                  <div ref={this.scrollTopEl}>
                    <Table>
                      <thead>
                        <tr>
                          <th>name</th>
                          <th>phone.no</th>
                          <th>content</th>
                          <th>discount used</th>
                          <th>notification clicked</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!getPushNotifications.data ? (
                          <td colspan="10" style={{ textAlign: "center" }}>
                            <h5>No Data Found</h5>{" "}
                          </td>
                        ) : (
                          getPushNotifications.data.map((u) => (
                            <tr>
                              <td>
                                {u.lead_name.name && u.lead_name.name == null
                                  ? " "
                                  : u.lead_name.name}
                              </td>
                              <td>{u.lead_name.mobile_no}</td>
                              <td>{u.notification_text}</td>
                              <td>-</td>
                              <td>
                                {u.is_read === 0 ? "Not Clicked" : "Clicked"}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                    {this.state.S_loading ? (
                      ""
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <Pagination>
                          <Pagination.First
                            onClick={this.s_paginationinfo.bind(
                              this,
                              this.state.S_prevpage
                            )}
                            disabled={this.state.S_prevdisabled}
                          />
                          {this.state.S_paginationData.map((url) => (
                            <Pagination.Item
                              active={
                                this.state.S_currentPage == url ? "1" : null
                              }
                              onClick={this.s_paginationinfo.bind(this, url)}
                            >
                              {url}
                            </Pagination.Item>
                          ))}
                          <Pagination.Last
                            onClick={this.s_paginationinfo.bind(
                              this,
                              this.state.S_nextpage
                            )}
                            disabled={this.state.S_nextdisabled}
                          />
                        </Pagination>
                      </div>
                    )}
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    bsStyle="danger"
                    fill
                    onClick={this.closeusertrasactionmodal.bind(this)}
                  >
                    Cancel
                  </Button>
                </Modal.Footer>
              </Modal>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default ViewNotifications;
